import { render, staticRenderFns } from "./ConfirmationDialogue.vue?vue&type=template&id=46aee0c6&"
import script from "./ConfirmationDialogue.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports